export default __webpack_public_path__ + "static/media/F387E892-3527-4CBB-A840-CD9D2756CAFF.0fc23320.jpg";